import styled from 'styled-components';

import { colors } from 'common/styles/style-constants';

export const CheckoutTimerWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`;

export const CheckoutTimerText = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 16px;
  font-weight: 500;
  color: ${colors.navy};
`;
